export const EVENT_RESULT_TYPES = {
    SCRIPT: 'eventWithScript',
    FREE: 'freeFormResult',
    FORM: 'formResult',
    FILE: 'resultFromDisk'
};

export const EXCLUDE_FILE_TYPES = ['bmp', 'gif'];
export const MAX_FILE_SIZE = 33554432;
export const EVALUATIONS = [
    {id: 'good', value: 'events.good'},
    {id: 'neutral', value: 'events.neutral'},
    {id: 'bad', value: 'events.bad'}
];

export const eventCoexecutiveListTypes = {
    'CntZakSotrList': 'participantPersonalList',
    'CntSoispList': 'coexecutiveList',
};

export const WAITING_EVENT_TYPE = 3346;
export const PROBATION_EVENT_TYPE = 3344;
export const WORKFLOW_EVENT_TYPES = [
    PROBATION_EVENT_TYPE,
    WAITING_EVENT_TYPE,
];

export const WORKING_PROBATION_DICT = [
    {id: 'Yes', name: 'passedProbation'},
    {id: 'No', name: 'didntPass'}
];

export const WORKING_WAITING_DICT = [
    { id: 'Yes', name: 'startWorking'},
    { id: 'No', name: 'didntStart'}
];

export const WORKING_PASSED_CODE = 'Yes';

export const INTERVIEW_WITH_RECRUTER = 1025;
export const VER_REK_CODE = 5127;
export const VER_REK_XMLTYPE = 'PplVerRek';

export const requiredContactEventTypes = [3073, 5126];
export const notRequiredCompanyEventTypes = [VER_REK_CODE];

export const DEFAULT_PROBATION = 90;

